// extracted by mini-css-extract-plugin
export default {"checkpointsList":"Checkpoints_checkpointsList__668dv"};